var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{attrs:{"src":_vm.getImage()}})
}
var staticRenderFns = []

export { render, staticRenderFns }